import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import type { IRadioInputProps } from './IRadioInputProps';

const RadioInput = forwardRef<HTMLInputElement, IRadioInputProps>(
  (props, forwardedRef) => {
    const {
      title,
      description,
      icon: Icon,
      iconUrl,
      className,
      ...rest
    } = props;

    if (Icon && iconUrl) {
      throw new Error('Radio Input cannot use both icon and iconUrl');
    }

    return (
      <div className="flex w-full items-center">
        <label className="flex w-full items-center gap-3" htmlFor={rest.id}>
          {Icon || null}
          {iconUrl ? (
            <img
              src={iconUrl}
              alt="radio-input-image"
              height={48}
              width={48}
              className="h-12 w-12"
              loading="eager"
            />
          ) : null}
          <span>
            <h2 className="block text-start font-semibold text-gray-600">
              {title}
            </h2>
            {description ? (
              <p className="text-mobile-gray-400 mt-1 block">{description}</p>
            ) : null}
          </span>
        </label>
        <input
          className={twMerge('accent-primary-500 ml-auto h-6 w-6', className)}
          type="radio"
          ref={forwardedRef}
          {...rest}
        />
      </div>
    );
  }
);

RadioInput.displayName = 'RadioInput';

export default RadioInput;
